import axios from 'axios';

const api = axios.create({
  baseURL: '/api',        // if you don't proxy /api on same domain, use full API origin here
  withCredentials: true,  // required for cookie-based auth
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;